/** biome-ignore-all lint/style/useNamingConvention: Google consent mode reserved keys */
interface IGtagWindow {
  gtag?: (...args: unknown[]) => void;
}

export function updateConsent(granted: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as Window & IGtagWindow;
  if (typeof w.gtag !== 'function') {
    return;
  }
  const value = granted ? 'granted' : 'denied';
  w.gtag('consent', 'update', {
    ad_storage: value,
    analytics_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
}
